import { useMemo } from "react";
import { getEnvFeatures } from "../helpers/env";
import { Settings } from "../helpers/settings";
import { useSettings } from "./settings";

let envFeatures: NonNullable<Settings["features"]> = {};
try {
  const raw = getEnvFeatures();
  if (raw) envFeatures = JSON.parse(raw);
} catch {}

export const useFeatures = (): NonNullable<Settings["features"]> => {
  const [settings] = useSettings();
  return useMemo(() => ({
    ...envFeatures,
    ...(settings.features ?? {}),
  }), [settings.features]);
};
